import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { useHeaderProps } from '../../components/Header/useProps'
import { useFooterProps } from '../../components/Footer/useProps'
import { selectors } from '../../redux'

import { DefaultLayoutProps } from './index'

export const useDefaultLayoutProps = (): DefaultLayoutProps => {
  const { t } = useTranslation()
  const locale = useSelector(selectors.app.currentLocale)
  const headerProps = useHeaderProps()
  const footerProps = useFooterProps()

  return useMemo(
    () => ({
      helmet: {
        title: t('seo.title'),
        htmlAttributes: {
          lang: locale,
        },
      },
      header: <Header {...headerProps} />,
      footer: <Footer {...footerProps} />,
    }),
    [headerProps, footerProps, t, locale]
  )
}
